/*
 * The texts of the teams extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		team: {
			create: 'Create team',
			edit: 'Edit team',
			settings: 'Team settings',
		},
	},
	pages: {
		admin: {
			teams: {
				title: 'Teams',
				create: 'Create team',
				edit: 'Edit team',
				users: 'People',
				events: 'Events',
			},
		},
		settings: {
			teams: {
				title: 'Teams',
			},
		},
	},
	sidebar: {
		teams: 'Teams',
	},
	modals: {
		admin: {
			edit_team: {
				create: 'Create new team',
				edit: 'Edit team',
				users: 'People',
			},
		},
	},
	data: {
		team: {
			id: 'Id',
			name: 'Name',
			users_count: '# People',
			events_count: '# Events',
		},
	},
	notifications: {
		assigned_to_team: {
			icon: 'fa-building',
			title: 'Added to team',
			text: "You have been added to the team '{team_name}'.",
		},
	},
	contexts: {
		team: 'Team',
	},
};
